import * as React from 'react';
import { BaseRouteProps } from '../../interfaces';
import { User, Survey } from '../../models';
import { SurveyDataService, UserDataService } from '../../services';
import { NavLink } from 'react-router-dom';
import { TopNavMenu } from '../navigation/TopNavMenu';

interface SurveyVersionCreateState {
    users: User[];
    surveys: Survey[];
}

export class SurveyVersionCreate extends React.Component<BaseRouteProps<{}>, SurveyVersionCreateState> {
    private surveyDataService = new SurveyDataService(this.props.notificationService);
    private userDataService = new UserDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{}>) {
        super(props);

        this.state = {
            users: new Array<User>(),
            surveys: new Array<Survey>(),
        };

        this.save = this.save.bind(this);
    }

    public componentDidMount() {
        this.userDataService.getAll().then((users: User[]) => {
            this.setState({ users: users });
        });

        this.surveyDataService.getAll().then((surveys: Survey[]) => {
            this.setState({ surveys: surveys });
        });
    }

    public render() {
        return (
            <div>
                <TopNavMenu open={true} />

                <div className="content-header">
                    <div className="content-container">
                        <NavLink to={'/surveyinstance'}>
                            <span className="glyphicon glyphicon-triangle-left" /> back
                        </NavLink>
                        <h1>Create Survey Version</h1>
                    </div>
                </div>

                {/* <div className="content-body">
                    <div className="content-container">
                        <Form onSubmit={submittedValues => this.save(submittedValues)}>
                            {formApi => (
                                <form onSubmit={formApi.submitForm} id="entityForm">
                                    <div className="form-group">
                                        <label htmlFor="userId">User</label>
                                        <Select className="form-control" field="userId" id="userId" options={userOptions} />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="surveyId">Survey</label>
                                        <Select className="form-control" field="surveyId" id="surveyId" options={surveyOptions} />
                                    </div>

                                    <button type="submit" className="btn btn-primary">Submit</button>
                                </form>
                            )}
                        </Form>
                    </div>
                </div> */}
            </div>);
    }

    private save(values: any) {
        // const survey = this.state.surveys.find(survey => {
        //     return survey.id === values.surveyId;
        // });

        // const user = this.state.users.find(user => {
        //     return user.id === values.userId;
        // });

        // if (survey && user) {

        //     this.surveyVersionDataService.getActive(survey).then((surveyVersion : SurveyVersion) => {

        //         const newSurveyInstance = new SurveyInstance(user, surveyVersion);
        //         this.surveyInstanceDataService.create(newSurveyInstance).then((success) => {
        //             this.props.history.push('/surveyinstance');
        //         });
        //     });
        // }
    }
}


// WEBPACK FOOTER //
// ./src/components/surveyversion/SurveyVersionCreate.tsx